/*************************************************/
/* BANNER                                        */
/*************************************************/

export function banner() {
    let resizeTimer;

    const init = function () {
        let campaignStamp = $('.campaign-stamp--department');

        //Make sure the campaign stamp is at the right position
        $(window).on("resize", function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
               
                var offsetElement = document.getElementsByClassName('banner__text')[0];
                
                if (offsetElement) {
                    const styles = offsetElement.currentStyle || window.getComputedStyle(offsetElement);
                    
                    campaignStamp.css('right', styles.marginRight);

                    const opacity = campaignStamp.css('opacity');
                   
                    if (opacity === '0') {
                        campaignStamp.css('opacity', '1');
                    }
                }
            }, 100);
        });

        $(window).trigger('resize');
    };

    init();
}

